export const MAX_PHOTOS_PER_POST = 10;
export const MAX_CAPTION_LENGTH = 2000;
/** Max Locations (accounts) that can be tagged/mentioned on a single social post.
 * See https://www.ayrshare.com/docs/testing/post-verification#mentions for more details.
 */
export const MAX_TAGGED_LOCATIONS = 5;
/** Instagram only lets posts photo-tag public accounts, so tags for a private Location account are skipped at publish. */
export const PRIVATE_INSTAGRAM_TAG_WARNING = "Private Instagram account, must be public for photo tagging.";
